import * as angular from 'angular';
(window as any).angular = angular;
import 'zone.js'; // Zone JS is required by Angular
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './appNg/app.module';

// Configure moment locale (moved from app.js)
import * as moment from 'moment';
import 'moment/locale/sv';
moment.locale('sv');

// Global styles (moved from app.component.ts)
import './appNg/styles.scss';
import './style/bootstrap3.less'; // Bootstrap 3 with .bs3 prefix
import './style/app.scss';

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
